import { render, staticRenderFns } from "./ZigZag.vue?vue&type=template&id=0cb43658&scoped=true"
import script from "./ZigZag.vue?vue&type=script&lang=js"
export * from "./ZigZag.vue?vue&type=script&lang=js"
import style0 from "./ZigZag.vue?vue&type=style&index=0&id=0cb43658&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cb43658",
  null
  
)

export default component.exports